/**
 * Brands block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS alongside its JS.
 * Swiper is lazy-loaded only when the block is present on the page. GSAP is
 * lazy-loaded only when the block is present and motion is allowed.
 */

import './index.scss';

const brandsBlocks = document.querySelectorAll('.brands');
const swiperEls = document.querySelectorAll('[data-brands-swiper]');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (swiperEls.length) {
	(async () => {
		const [{ default: Swiper }, { A11y, Autoplay }] = await Promise.all([
			import('swiper'),
			import('swiper/modules'),
			import('swiper/css'),
		]);

		swiperEls.forEach((el) => {
			new Swiper(el, {
				modules: [Autoplay, A11y],
				slidesPerView: 2,
				spaceBetween: 16,
				loop: true,
				allowTouchMove: !reduceMotion,
				a11y: { enabled: true },
				// delay:0 + a long speed makes autoplay read as a continuous
				// marquee instead of discrete slide-by-slide steps.
				speed: 4000,
				autoplay: reduceMotion
					? false
					: {
							delay: 0,
							disableOnInteraction: false,
						},
				breakpoints: {
					768: { slidesPerView: 3, spaceBetween: 24 },
					1024: { slidesPerView: 5, spaceBetween: 24 },
				},
			});
		});
	})();
}

// The logo tiles live inside the Swiper carousel and are always visible —
// no scroll-triggered fade-in for them, since that would race Swiper's own
// async init and risk measuring the carousel before its layout settles.
// Only the heading gets the reveal animation.
if (brandsBlocks.length && !reduceMotion) {
	brandsBlocks.forEach((block) => {
		if (block.getBoundingClientRect().bottom > 0) {
			block.dataset.animate = '';
		}
	});

	(async () => {
		const { gsap } = await import('gsap');
		const { ScrollTrigger } = await import('gsap/ScrollTrigger');

		gsap.registerPlugin(ScrollTrigger);

		document.querySelectorAll('.brands[data-animate]').forEach((block) => {
			const heading = block.querySelector('.brands__heading');

			if (!heading) {
				return;
			}

			const ctx = gsap.context(() => {
				gsap.to(heading, {
					opacity: 1,
					y: 0,
					duration: 0.8,
					ease: 'power3.out',
					scrollTrigger: {
						trigger: block,
						start: 'top 90%',
						once: true,
					},
				});
			}, block);

			block._gsapCtx = ctx;
		});
	})();
}
